export default class ExtensionCategoryQuestionModel {
  public extensionCategoryQuestionId: string = ''
  public extensionCategoryId: string = ''
  public question: string = ''
  public isBarrier: boolean = false
  public isChange: boolean = false
  public isHumanFactor: boolean = false
  public isEvent: boolean = false
  public isData: boolean = false
  public order: number = 0
  public isChecked: boolean = false
  public answerId: string = ''
  public answerAndCategory: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
